export default __webpack_public_path__ + "static/media/chocho_l.eb42e0c8.jpg";